// adding service category
import React, { useState, useEffect } from 'react';
import './AddInventoryModal.css';
import PlusIcon from '../../assets/svg/plusIcon.svg';

const AddInventoryModal = ({ handleCloseModal, user, onAddCategory }) => {
	const [newCategory, setNewCategory] = useState('');
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [successMessage, setSuccessMessage] = useState('');

	useEffect(() => {
		const fetchCategories = async () => {
			try {
				const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inventory/service-categories-inventory/${user.account_id}`);
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const data = await response.json();
				setCategories(data);
			} catch (error) {
				console.error('Error fetching categories', error);
			}
		};

		fetchCategories();
	}, [user]);

	const handleAddCategory = async () => {
		if (newCategory.trim() !== '' && !categories.some((category) => category.title === newCategory)) {
			const newCategoryObject = { title: newCategory, account_id: user.account_id };

			setLoading(true);
			setError(''); // Clear previous error message

			try {
				const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inventory/add_new_category/${user.account_id}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(newCategoryObject),
				});

				const responseData = await response.json();

				if (!response.ok) {
					const errorText = responseData.error || responseData.message || 'Unknown error';
					setError(`Failed to add category: ${errorText}`); // Set error message state
					throw new Error(`Failed to add category: ${errorText}`);
				}

				setCategories((prevCategories) => [...prevCategories, responseData]);
				setNewCategory(''); // Clear the input after adding
				setSuccessMessage('Category created successfully!'); // Set success message
				setTimeout(() => {
					setSuccessMessage('');
				}, 3000);
			} catch (error) {
				console.error('Error adding category:', error);
			} finally {
				setLoading(false);
			}
		} else {
			setError('Category name is either empty or already exists.'); // Set error message for empty or duplicate category
		}
	};

	return (
		<div className="modal-overlay">
			<div className="modal">
				<div className="modal-header">
					<p className="header-txt">Add Category</p>
					<span className="close" onClick={handleCloseModal}>
						&times;
					</span>
				</div>
				<div className="modal-body">
					<div>
						<div className="add-inventory-content">
							<div className="add-bar">
								<input className="add-inventory-input" type="text" placeholder="Add new category" value={newCategory} onChange={(e) => setNewCategory(e.target.value)} />
								<img
									src={PlusIcon}
									alt="Add Category"
									className={`primary-icon ${newCategory.length > 0 && !loading ? 'clickable' : 'disabled'}`}
									onClick={newCategory.length > 0 && !loading ? handleAddCategory : null}
								/>
							</div>
							{error && <p className="error-message">{error}</p>}
							{successMessage && <p className="success-message">{successMessage}</p>}
						</div>
						<p className="inventory-label">Existing Categories</p>
						<ul className="list">
							{categories.map((category) => (
								<li className="list-item" key={category.id}>
									{category.title}
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddInventoryModal;
